import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('base-modal-layout', {
  root: {
    variants: {
      skin: ['standard', 'premium', 'destructive'],
      controlButtonAmount: ['0', '1', '2'],
    },
  },
  controlButtons: {},
  helpButton: {},
  closeButton: {},
  helpIcon: {},
});
